import { forwardRef, type Ref, type SVGProps } from "react";
const IconHideFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m0 4a9.9 9.9 0 0 1 5.51 1.66L7.66 21.51A10 10 0 0 1 16 6m0 20a9.9 9.9 0 0 1-5.51-1.66l13.85-13.85A10 10 0 0 1 16 26" />
  </svg>
);
const ForwardRef = forwardRef(IconHideFilledSVG);
ForwardRef.displayName = "IconHideFilled";
export { ForwardRef as IconHideFilled };
